(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['exports', 'echarts'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports, require('echarts'));
    } else {
        // Browser globals
        factory({}, root.echarts);
    }
}(this, function (exports, echarts) {
    var log = function (msg) {
        if (typeof console !== 'undefined') {
            console && console.error && console.error(msg);
        }
    };
    if (!echarts) {
        log('ECharts is not Loaded');
        return;
    }
    echarts.registerTheme('shine', {
        "color": [
            "#01e1e7",
            "#c12e34",
            "#e6b600",
            "#0098d9",
            "#2b821d",
            "#005eaa",
            "#339ca8",
            "#f08503",
            "#83df4e",
            "#7c0202"
        ],
        "backgroundColor": "rgba(8,24,52,0)",
        "textStyle": {},
        "title": {
            "textStyle": {
                "color": "#333333"
            },
            "subtextStyle": {
                "color": "#bbbbbb"
            }
        },
        "line": {
            "itemStyle": {
                "borderWidth": 1
            },
            "lineStyle": {
                "width": 2
            },
            "symbolSize": 10,
            "symbol": "circle",
            "smooth": false
        },
        "radar": {
            "itemStyle": {
                "borderWidth": 1
            },
            "lineStyle": {
                "width": 2
            },
            "symbolSize": 10,
            "symbol": "circle",
            "smooth": false
        },
        "bar": {
            "itemStyle": {
                "barBorderWidth": 0,
                "barBorderColor": "#ccc"
            }
        },
        "pie": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "scatter": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "boxplot": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "parallel": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "sankey": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "funnel": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "gauge": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "candlestick": {
            "itemStyle": {
                "color": "#c12e34",
                "color0": "#2b821d",
                "borderColor": "#c12e34",
                "borderColor0": "#2b821d",
                "borderWidth": 1
            }
        },
        "graph": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "lineStyle": {
                "width": 1,
                "color": "#aaaaaa"
            },
            "symbolSize": 10,
            "symbol": "circle",
            "smooth": false,
            "color": [
                "#01e1e7",
                "#c12e34",
                "#e6b600",
                "#0098d9",
                "#2b821d",
                "#005eaa",
                "#339ca8",
                "#f08503",
                "#83df4e",
                "#7c0202"
            ],
            "label": {
                "color": "#bbbbbb"
            }
        },
        "map": {
            "itemStyle": {
                "areaColor": "#ddd",
                "borderColor": "#eee",
                "borderWidth": 0.5
            },
            "label": {
                "color": "#c12e34"
            },
            "emphasis": {
                "itemStyle": {
                    "areaColor": "#e6b600",
                    "borderColor": "#ddd",
                    "borderWidth": 1
                },
                "label": {
                    "color": "#c12e34"
                }
            }
        },
        "geo": {
            "itemStyle": {
                "areaColor": "#ddd",
                "borderColor": "#eee",
                "borderWidth": 0.5
            },
            "label": {
                "color": "#c12e34"
            },
            "emphasis": {
                "itemStyle": {
                    "areaColor": "#e6b600",
                    "borderColor": "#ddd",
                    "borderWidth": 1
                },
                "label": {
                    "color": "#c12e34"
                }
            }
        },
        "categoryAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#bbbbbb"
            },
            "splitLine": {
                "show": false,
                "lineStyle": {
                    "color": [
                        "#394559"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "rgba(250,250,250,0.3)",
                        "rgba(200,200,200,0.3)"
                    ]
                }
            }
        },
        "valueAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#bbbbbb"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#394559"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "rgba(250,250,250,0.3)",
                        "rgba(200,200,200,0.3)"
                    ]
                }
            }
        },
        "logAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#bbbbbb"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#394559"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "rgba(250,250,250,0.3)",
                        "rgba(200,200,200,0.3)"
                    ]
                }
            }
        },
        "timeAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#bbbbbb"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#bbbbbb"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#394559"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "rgba(250,250,250,0.3)",
                        "rgba(200,200,200,0.3)"
                    ]
                }
            }
        },
        "toolbox": {
            "iconStyle": {
                "borderColor": "#bbbbbb"
            },
            "emphasis": {
                "iconStyle": {
                    "borderColor": "#ffffff"
                }
            }
        },
        "legend": {
            "textStyle": {
                "color": "#ffffff"
            }
        },
        "tooltip": {
            "axisPointer": {
                "lineStyle": {
                    "color": "#cccccc",
                    "width": 1
                },
                "crossStyle": {
                    "color": "#cccccc",
                    "width": 1
                }
            }
        },
        "timeline": {
            "lineStyle": {
                "color": "#005eaa",
                "width": 1
            },
            "itemStyle": {
                "color": "#005eaa",
                "borderWidth": 1
            },
            "controlStyle": {
                "color": "#005eaa",
                "borderColor": "#005eaa",
                "borderWidth": 0.5
            },
            "checkpointStyle": {
                "color": "#005eaa",
                "borderColor": "#316bc2"
            },
            "label": {
                "color": "#005eaa"
            },
            "emphasis": {
                "itemStyle": {
                    "color": "#005eaa"
                },
                "controlStyle": {
                    "color": "#005eaa",
                    "borderColor": "#005eaa",
                    "borderWidth": 0.5
                },
                "label": {
                    "color": "#005eaa"
                }
            }
        },
        "visualMap": {
            "color": [
                "#1790cf",
                "#a2d4e6"
            ]
        },
        "dataZoom": {
            "backgroundColor": "rgba(47,69,84,0)",
            "dataBackgroundColor": "rgba(47,69,84,0.3)",
            "fillerColor": "rgba(167,183,204,0.4)",
            "handleColor": "#a7b7cc",
            "handleSize": "100%",
            "textStyle": {
                "color": "#333333"
            }
        },
        "markPoint": {
            "label": {
                "color": "#bbbbbb"
            },
            "emphasis": {
                "label": {
                    "color": "#bbbbbb"
                }
            }
        }
    });
}));
